export const CREATE_FILTER = 'CREATE_FILTER';

const setFilterAction = (key, data) => (dispatch) => {
  try {
    dispatch({
      type: CREATE_FILTER,
      payload: {
        key,
        data,
      },
    });
  } catch (error) {
    return null;
  }
};

export { setFilterAction };
